// extracted by mini-css-extract-plugin
export default {"container_banner":"BannerHome_container_banner__x78Tf","banner_img":"BannerHome_banner_img__yxCwP"};